import { render, staticRenderFns } from "./CreateBulkRoles.vue?vue&type=template&id=38c2b3e0&scoped=true&"
import script from "./CreateBulkRoles.vue?vue&type=script&lang=js&"
export * from "./CreateBulkRoles.vue?vue&type=script&lang=js&"
import style0 from "./CreateBulkRoles.vue?vue&type=style&index=0&id=38c2b3e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c2b3e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VCol,VContainer,VDataTable,VRow,VSelect,VSnackbar})
